import { BaseModel } from "../../../../ensue-react-system/utilities/base-model";
import { FootballTeam } from "../football-team";
import { IFootballTeam } from "../interface/i-football-team";
import { IManageFootballCompetitionInvitedTeam } from "./interface/i-manage-football-competition-invited-team";

export class ManageFootballCompetitionInvitedTeam extends BaseModel implements IManageFootballCompetitionInvitedTeam {
  public id: number = 0;
  public status: string = "";
  public invitedTeamId: number = 0;
  public selectedTeamId: number = 0;
  public selectedTeam: IFootballTeam | null = null;
  public invitedTeam: IFootballTeam = new FootballTeam();

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
